// MapboxHeatmap.jsx
import { useMemo, useState } from "react";
import { Source, Layer, Popup } from "react-map-gl";

const MapboxHeatmap = ({ palms = [], tileset }) => {
  const [selectedPalm, setSelectedPalm] = useState(null);


  const colorCero = "#ff0000" 
  const colorOne = "#FFA64D" 
  const colorTwo = "#FFFF66"
  const colorThree = "#80DFFF"
  const colorFour = "#3333FF"

  const features = useMemo(() => {
    if (!Array.isArray(palms)) return [];
    return palms.reduce((acc, p) => {
      const coords = p?.location?.coordinates;
      const lon = Number(coords?.[0]);
      const lat = Number(coords?.[1]);
      if (Number.isFinite(lon) && Number.isFinite(lat)) {
        acc.push({
          type: "Feature",
          geometry: { type: "Point", coordinates: [lon, lat] },
          properties: {
            total: p?.totalFirstApplications ?? 0,
            palmName: p?.palmName,
            lotName: p?.lotName,
            lineName: p?.lineName,
          },
        });
      }
      return acc;
    }, []);
  }, [palms]);

  const geojson = useMemo(
    () => ({
      type: "FeatureCollection",
      features,
    }),
    [features]
  );

  const layerStyle = {
    id: "palms-layer",
    type: "circle",
    source: "palms",
    paint: {
      "circle-radius": 6,
      "circle-stroke-width": 1,
      "circle-stroke-color": "#000",
      "circle-color": [
        "case",
        ["==", ["get", "total"], 0], colorCero,
        ["==", ["get", "total"], 1], colorOne,
        ["==", ["get", "total"], 2], colorTwo,
        ["==", ["get", "total"], 3], colorThree,
        [">=", ["get", "total"], 4], colorFour,
        "#CCCCCC"
      ],
    },
  };



  if (features.length === 0) return null;

  return (
    <>

      {tileset && (
        <>
          <Source
            id="ortomosaico"
            type="raster"
            url={`mapbox://${tileset}`}
            tileSize={256}
          />
          <Layer
            id="ortomosaico-layer"
            type="raster"
            source="ortomosaico"
            paint={{ "raster-opacity": 1 }}
          />
        </>
      )}


      <Source
        id="palms"
        type="geojson"
        data={geojson}
      >
        <Layer {...layerStyle} />
      </Source>

    </>
  );
};

export default MapboxHeatmap;
